export const SliderItemJob = {
	name: 'SliderItemJob',
	props: {
		perPage: {
			type: Number,
			default: 6,
		}
	},
	render(h) {
		if (!this.$slots.default) { return; }

		let slots = this.$slots.default.filter(slot => slot.tag);

		let slides = [];
		let pages = slots.reduce((pages, slot, index) => {
			//Add Slots to Array of Slides
			let size = Math.ceil(this.perPage/2);
			slides.push(h('div', { class: 'slider__item', style: { width: `calc(100% / ${size})`, marginBottom: '50px', alignSelf: 'flex-start' } }, [slot]));

			//If hit number of per page or is last slots
			if (slides.length == this.perPage || (slots.length - 1) == index) {
				//Add Slides to Array Pages
				pages.push(h('div', { class: ['slide'], style: { 	flexWrap: 'wrap' } }, slides));
				//Rest Array of Slides
				slides = [];
			}

			//Return Pages
			return pages
		}, []);

		if (pages.length == 1) {
			pages[0].data.style = { 'justify-content': 'center' };
		}

		this.$parent.$emit('update-data', pages.length, 1);

		return h('div', { class: ['slide__wrapper'] }, [pages]);
	}
}
